import { SET_PREVIOUS_ROUTE } from '~/store/mutationTypes';

/** @type {import('@nuxt/types').Middleware} */
const middleware = ({ from, store }) => {
    store.commit(SET_PREVIOUS_ROUTE, from?.path ?? '');
};

export default middleware;
